<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterAccount" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="accountData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight">
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="userId" :visible="false"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="realName" :headerText="$t('Security.User.realname')" width="120" textAlign="Center"></e-column>
            <e-column field="statusName" :headerText="$t('Security.User.status')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getAccountList"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addAccountDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <AddAccount ref="addAccountPage" :index="addIndex"></AddAccount>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="editAccountDialog"
        v-bind:element="editDialog.element"
        v-bind:styles="editDialog.styles"
      >
        <template v-slot:dialog-content>
          <EditAccount ref="editAccountPage"></EditAccount>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import AddAccount from '../../components/security/accountManager/addAccount';
import EditAccount from '../../components/security/accountManager/editAccount';

export default {
  name: 'AccountManager',
  data() {
    return {
      accountData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.userManage')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteAccount },
        { prefixIcon: 'icon hero-icon hero-icon-business-operation', tooltipText: this.$t('Login.updPasswdTitle'), click: this.modifyPwdShow },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid }
      ],
      keyword: '',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      addIndex: 0,
      editId: '',
      addStatus: true,
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addAccountDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.prevAdd,
              buttonModel: {
                content: `${this.$t('Common.previous')}`,
                cssClass: 'h-security-display-none'
              }
            },
            {
              click: this.nextAdd,
              buttonModel: { content: `${this.$t('Common.next')}` }
            }
          ],
          title: `${this.$t('Security.addUser')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'edit',
          title: `${this.$t('Security.editUser')}`,
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.modifyAccount,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ]
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
    AddAccount,
    EditAccount
  },
  mounted() {
    this.getAccountList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getAccountList() {
      const url = '/lte/ems/user/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        username: this.keyword,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          let date = new Date();
          date.setTime(v.createTime);
          v.createTime = date;
        });
        That.accountData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    filterAccount() {
      this.getAccountList();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showAddDialog() {
      this.$refs.addAccountPage.init();
      this.$refs.addAccountDialog.show();
    },
    showModifyDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.editId = record[0].userId;
      this.$refs.editAccountPage.findEditAccount(this.editId);
      this.$refs.editAccountDialog.show();
    },
    deleteAccount() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/ems/user/delete';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.userId);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getAccountList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    addAccount() {
      if (this.addStatus) {
        this.addStatus = false;
        const url = '/lte/ems/user/add';
        const accountInfo = this.$refs.addAccountPage.getAddInfo();
        if(accountInfo == null) {
          this.addStatus = true;
          return;
        }
        let That = this;
        this.axios.post(url, accountInfo).then(response => {
          const result = response.data;
          if(result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getAccountList();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addIndex = 0;
          That.addStatus = true;
          That.$refs.addAccountDialog.clear();
          That.$refs.addAccountDialog.close();
        });
      }
    },
    modifyAccount() {
      const url = '/lte/ems/user/edit';
      const accountInfo = this.$refs.editAccountPage.getEditInfo();
      if(accountInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, accountInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getAccountList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
        That.$refs.editAccountDialog.clear();
        That.$refs.editAccountDialog.close();
      });
    },
    dialogHide() {
      this.addIndex = 0;
      this.$refs.addAccountDialog.clear();
      this.$refs.addAccountDialog.close();
      this.$refs.editAccountDialog.clear();
      this.$refs.editAccountDialog.close();
    },
    modifyPwdShow() {
      let record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.$parent.updPwdAccountId = record[0].userId;
      this.$parent.$refs.pwdDialog.show();
      this.$parent.$refs.modiyPwd.initStrategy();
    },
    refreshGrid() {
      this.getAccountList();
    },
    copyDeep(templateData) {
      const returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    },
    prevAdd() {
      if (this.addIndex !== 0) {
        this.addIndex -= 1;
      }
    },
    nextAdd() {
      if (this.addIndex === 2) {
        this.addAccount();
      } else if (this.addIndex === 0) {
        let status = this.$refs.addAccountPage.validation();
        if (status) {
          this.addIndex += 1;
        }
      } else {
        this.addIndex += 1;
      }
    }
  },
  watch: {
    addIndex() {
      const temp = this.copyDeep(this.addDialog.element);
      if (this.addIndex === 2) {
        temp.buttonGroup[2].buttonModel.content = `${this.$t('Common.ok')}`;
        temp.buttonGroup[2].buttonModel.cssClass = 'primary-btn';
      } else {
        temp.buttonGroup[2].buttonModel.content = `${this.$t('Common.next')}`;
        temp.buttonGroup[2].buttonModel.cssClass = '';
      }
      if (this.addIndex === 0) {
        temp.buttonGroup[1].buttonModel.cssClass = 'h-security-display-none';
      } else {
        temp.buttonGroup[1].buttonModel.cssClass = 'h-security-display-block';
      }
      this.addDialog.element = temp;
    },
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
